export default __webpack_public_path__ + "static/media/logo-dark-mode.cd2c531c.png";